import { motion } from "framer-motion";
import type { ReactNode } from "react";
import usePrefersReducedMotion from "../hooks/usePrefersReducedMotion";

export default function PageTransition({ children }: { children: ReactNode }) {
  const reducedMotion = usePrefersReducedMotion();

  if (reducedMotion) {
    // A plain cross-fade, no vertical motion and no brand-bar sweep — the
    // ZP-93/ZP-90 AC's own wording ("simplified to a simple cross-fade or
    // removed entirely").
    return (
      <motion.main initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.15 }}>
        {children}
      </motion.main>
    );
  }

  return (
    <>
      {/* Branded page-transition accent: a thin teal bar sweeping in from
          the left as the new page enters, standing in for a literal logo
          wipe without one playing out on every single internal nav click —
          same "recognizable brand motif, not a full-screen animation" scale
          as the rest of this site's micro-interactions. */}
      <motion.div
        aria-hidden="true"
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
        style={{ transformOrigin: "left" }}
        className="fixed inset-x-0 top-0 z-[60] h-0.5 bg-teal-400"
      />
      <motion.main
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -16 }}
        transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
      >
        {children}
      </motion.main>
    </>
  );
}
